import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Heading, Text, HStack, VStack, Button, Spinner,
  Badge, Table, Thead, Tbody, Tr, Th, Td,
  Alert, AlertIcon,
} from '@chakra-ui/react';
import { FiRefreshCw } from 'react-icons/fi';

const API_BASE = '/api/v1';

const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Token ${localStorage.getItem('token')}`,
});

function Events() {
  const [events, setEvents] = useState([]);
  const [namespace, setNamespace] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchEvents = useCallback(() => {
    setLoading(true);
    setError(null);
    fetch(`${API_BASE}/k8s/events/`, { headers: getAuthHeaders() })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => {
        setEvents(data.events || []);
        setNamespace(data.namespace || '');
        setLoading(false);
      })
      .catch(err => { setError(err.message); setLoading(false); });
  }, []);

  useEffect(() => { fetchEvents(); }, [fetchEvents]);

  const typeColor = (type) => {
    switch (type) {
      case 'Normal': return 'green';
      case 'Warning': return 'orange';
      default: return 'gray';
    }
  };

  if (loading) return <Box textAlign="center" py={20}><Spinner size="xl" color="gray.500" /></Box>;
  if (error) return <Alert status="error" borderRadius="lg"><AlertIcon />{error}</Alert>;

  return (
    <Box>
      <HStack justify="space-between" mb={6}>
        <VStack align="start" spacing={1}>
          <Heading size="lg">Events</Heading>
          <Text color="gray.500">
            Recent events in namespace <Badge colorScheme="blue">{namespace}</Badge>
          </Text>
        </VStack>
        <Button leftIcon={<FiRefreshCw />} colorScheme="gray" onClick={fetchEvents}>Refresh</Button>
      </HStack>

      <Box bg="white" borderRadius="lg" boxShadow="md" overflow="hidden">
        <Table variant="simple" size="sm">
          <Thead bg="gray.50">
            <Tr>
              <Th>Type</Th>
              <Th>Reason</Th>
              <Th>Object</Th>
              <Th>Message</Th>
              <Th>Count</Th>
              <Th>Last Seen</Th>
            </Tr>
          </Thead>
          <Tbody>
            {events.map((ev, i) => (
              <Tr key={i} _hover={{ bg: 'gray.50' }}>
                <Td><Badge colorScheme={typeColor(ev.type)}>{ev.type}</Badge></Td>
                <Td><Text fontSize="sm" fontWeight="medium">{ev.reason}</Text></Td>
                <Td><Text fontSize="xs" fontFamily="mono" color="gray.600">{ev.object}</Text></Td>
                <Td><Text fontSize="xs" maxW="400px" isTruncated>{ev.message}</Text></Td>
                <Td><Badge>{ev.count}</Badge></Td>
                <Td>
                  <Text fontSize="xs" color="gray.500">
                    {ev.last_seen ? new Date(ev.last_seen).toLocaleString() : '—'}
                  </Text>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
}

export default Events;
